module.exports = __webpack_public_path__ + "static/media/107.70a6bd30.jpg";